import { render } from "./index.vue?vue&type=template&id=a2689f0a&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=a2689f0a&lang=less&scoped=true"

import exportComponent from "/Users/summer/Desktop/code/study_mp/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2689f0a"]])

export default __exports__